export enum MessageType {
    Notification = "Notification",
    Feedback = "Feedback",
}